// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_ev-a";
export var fulfillmentFormRail = "_ev-9";
export var headerTitleRow = "_ev-c";
export var orderDetailsWrapper = "_ev-7";
export var orderLinkTrigger = "_ev-2";
export var paymentInformationGrid = "_ev-h";
export var paymentSummaryColumn = "_ev-i";
export var shipmentContainer = "_ev-b";
export var shipmentDetailsMainPane = "_ev-8";
export var shipmentNavigationCard = "_ev-5";
export var shipmentNavigationRail = "_ev-3";
export var shipmentNavigationRailHeader = "_ev-4";
export var shipmentSummaryFact = "_ev-e";
export var shipmentSummaryGrid = "_ev-d";
export var shipmentSummaryMetadataRow = "_ev-f";
export var shipmentSummaryTags = "_ev-g";
export var shipmentWorkspace = "_ev-0";
export var shipmentWorkspaceContent = "_ev-6";
export var shipmentWorkspaceHeader = "_ev-1";